export default "__VITE_ASSET__7e7ba9ea__"